import React from 'react'
import './index.scss'
import { CustomBrandPageProps } from './types'

export const CustomBrandPage: React.FC<CustomBrandPageProps> = ({ children }) => {
  return <div className="custom-brand-page">{children}</div>
}
